import React from 'react';
import './footer.scss';

function Footer() {
  return (
      <footer className="footer">
        <div className="container">
          <row>
            Copyright 2023 Elina Razina
          </row>
        </div>
      </footer>
  );
}

export default Footer;
